// Storage guard — MUST be imported before any app module so it runs before
// components (and module-load reads) touch Web Storage.
//
// The Emergent in-app preview renders the app inside a sandboxed/partitioned
// webview where accessing window.localStorage / sessionStorage can throw a
// SecurityError (the browser masks it as a cross-origin "Script error."). A
// regular browser tab is unaffected. If either store is unavailable we swap in
// an in-memory shim so the ~dozens of `localStorage.x` call sites across the
// app degrade gracefully instead of crashing the app on load.
function makeMemStore() {
  let m = {};
  return {
    getItem: (k) => (Object.prototype.hasOwnProperty.call(m, k) ? m[k] : null),
    setItem: (k, v) => { m[k] = String(v); },
    removeItem: (k) => { delete m[k]; },
    clear: () => { m = {}; },
    key: (i) => Object.keys(m)[i] ?? null,
    get length() { return Object.keys(m).length; },
  };
}

['localStorage', 'sessionStorage'].forEach((name) => {
  let ok = false;
  try {
    const s = window[name];
    const probe = '__inzara_storage_probe__';
    s.setItem(probe, '1');
    s.removeItem(probe);
    ok = true;
  } catch (_) {
    ok = false;
  }
  if (!ok) {
    try {
      Object.defineProperty(window, name, { value: makeMemStore(), configurable: true });
    } catch (_) {
      // Cannot redefine the property in this environment — nothing more to do;
      // individual guarded call sites (try/catch) still degrade safely.
    }
  }
});
